import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 0 24px;
`;

export const HeaderCompanyCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 84px;
  min-width: 320px;
  flex: 1;
  padding: 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const CompanyAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
`;

export const CompanyAvatarFallback = styled.div`
  ${TypographyV2.b1};
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.Blue6};
  color: ${ColorV2.Blue1};
`;

export const CompanyMetaColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px;
`;

export const CompanyName = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const CompanyMeta = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SectionTitle = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const SectionSubTitle = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns:
    minmax(260px, 2.6fr) minmax(110px, 0.9fr) minmax(110px, 0.9fr)
    minmax(190px, 1.3fr);
  align-items: center;
  column-gap: 8px;
  padding: 14px 12px;
  border-radius: 12px;
  background: ${ColorV2.Blue7};

  > :nth-child(2),
  > :nth-child(3),
  > :nth-child(4) {
    justify-self: end;
  }
`;

export const Person = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PersonName = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const PersonMeta = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CellLabel = styled.span<{ $muted?: boolean }>`
  ${TypographyV2.s1};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue4)};
`;

export const CellValue = styled.span<{ $muted?: boolean }>`
  ${TypographyV2.b2};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue1)};
`;

export const StatusPill = styled.span<{
  $tone: "success" | "warning" | "info" | "danger" | "neutral";
}>`
  ${TypographyV2.s1};
  justify-self: end;
  display: inline-flex;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${(props) =>
    props.$tone === "success"
      ? "#e1f2e9"
      : props.$tone === "warning"
        ? "#f9f0db"
        : props.$tone === "info"
          ? "rgba(45, 141, 219, 0.14)"
          : props.$tone === "danger"
            ? "#fce9e9"
            : ColorV2.Blue6};
  color: ${(props) =>
    props.$tone === "success"
      ? ColorV2.PositiveGreen
      : props.$tone === "warning"
        ? ColorV2.DarkAmbigiousYellow
        : props.$tone === "info"
          ? ColorV2.ElectricBlue
          : props.$tone === "danger"
            ? ColorV2.NegativeRed
            : ColorV2.Blue2};
`;

export const Message = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  padding: 20px 8px;
`;

export const LoadMoreSentinel = styled.div`
  width: 100%;
  height: 1px;
`;
